export default __webpack_public_path__ + "static/media/eighttok.6ca23172.svg";